import React, { FC, forwardRef, ReactNode } from 'react';
import styled from 'styled-components';

import { HeaderContainer } from '../HeaderContainer/HeaderContainer';

interface CardProps {
  children: ReactNode;
  noBg?: boolean;
}

interface CardContentProps {
  children: ReactNode;
  minHeight?: string;
}

interface NgCardHeaderProps {
  children: ReactNode;
  filters?: ReactNode;
  hideFilters?: boolean;
  headerContent?: ReactNode;
  noBorder?: boolean;
}

interface NgCardTitleProps {
  title: string;
}

const StyledCard = styled.div<{ $noBg: boolean }>`
  width: 100%;
  overflow: visible;

  border: ${({ theme }) => `1px solid ${theme.palette.border}`};
  border-radius: ${({ theme }) => theme.radius.small};
  background-color: ${({ theme, $noBg }) => ($noBg ? 'none' : theme.palette.white)};
`;

const StyledCardContent = styled.div<{ $minHeight?: string }>`
  min-height: 100%;
  width: 100%;

  min-height: ${({ $minHeight }) => $minHeight || 'initial'};
  padding: ${({ theme }) => theme.spacing.medium};
`;

const StyledNgCardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

const StyledNgCardHeaderFilters = styled.div`
  min-height: 51px;
`;

const StyledCardTitle = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.palette.gray};
  font-size: ${({ theme }) => theme.fontSize.smaller};
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`;

export const NgCardTitle: FC<NgCardTitleProps> = ({ title }) => <StyledCardTitle>{title}</StyledCardTitle>;

export const NgCardHeader = forwardRef<HTMLDivElement, NgCardHeaderProps>(
  ({ children, filters, noBorder, hideFilters = false }, ref) => {
    return (
      <StyledNgCardHeader ref={ref}>
        <HeaderContainer noBorder={noBorder}>{children}</HeaderContainer>
        {!hideFilters && <StyledNgCardHeaderFilters>{filters}</StyledNgCardHeaderFilters>}
      </StyledNgCardHeader>
    );
  },
);

NgCardHeader.displayName = 'NgCardHeader';

export const NgCardContent: FC<CardContentProps> = ({ children, minHeight }) => {
  return <StyledCardContent $minHeight={minHeight}>{children}</StyledCardContent>;
};

export const NgCard: FC<CardProps> = ({ children, noBg = false }) => {
  return <StyledCard $noBg={noBg}>{children}</StyledCard>;
};
